import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import { Field } from '../types';

export interface LetterFormData {
  [key: string]: string;
}

const getSchema = (fields: Field[]) => {
  const shape = Object.fromEntries(
    fields.map(field => [field.name, field.schema]),
  );
  return yup.object().shape(shape);
};

const useLetterForm = (fields: Field[]) => {
  const { control, handleSubmit, reset, formState } = useForm<LetterFormData>({
    resolver: yupResolver(getSchema(fields)),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  return { control, handleSubmit, reset, isValid: formState.isValid };
};

export default useLetterForm;
